/* Reducers ---------------------------------------------------------------- */
import { isDataViewOnDemand } from 'cadenza/map/on-demand/on-demand-map.state';
import { keepSessionAlive } from 'cadenza/session-polling/session-poller';
import { getStore } from 'cadenza/store/cadenza-store';
import type { ViewId } from 'cadenza/workbook/api/view-id';
import {
  getLiveModeRefreshInterval,
  isLiveModeRunning,
} from 'cadenza/workbook/state/workbook-live-mode-selectors.state';
import type { LiveModeState, ViewDataRefreshEvent } from 'cadenza/workbook/state/workbook-live-mode.state';
import {
  getActiveWorksheet,
  getActiveWorksheetViewIds,
  getDataViewsByViewId,
} from 'cadenza/workbook/workbook-core-selectors.state';
import { slice } from 'cadenza/workbook/workbook-core-slice.state';
import { refreshViewData, startLiveMode, stopLiveMode } from 'cadenza/workbook/workbook.state';

export function toggleLiveMode() {
  if (isLiveModeRunning(getStore().getState())) {
    getStore().dispatch(stopLiveMode(true));
  } else {
    getStore().dispatch(startLiveMode());
  }
}

function handleLiveModeRefresh() {
  const state = slice(getStore().getState());
  const viewDataRefreshEvents: ViewDataRefreshEvent[] = getActiveWorksheetViewIds(state)
    .map((viewId: ViewId) => {
      return {
        viewId,
        dataViewIds: getDataViewsByViewId(state, viewId)
          .filter((dataView) => !isDataViewOnDemand(dataView))
          .map((dataView) => dataView.id),
      };
    })
    .filter(({ dataViewIds }) => dataViewIds.length > 0);
  getStore().dispatch(refreshViewData({ events: viewDataRefreshEvents }));
}

/* Action Creators --------------------------------------------------------- */
let liveModeRefreshTimer: number | undefined;

export function onLiveModeStateChange(liveModeState: LiveModeState) {
  const isRunning = liveModeState?.state === 'running';
  if (isRunning) {
    const worksheet = getActiveWorksheet(getStore().getState());
    const interval = getLiveModeRefreshInterval(worksheet);

    // Live mode timer
    liveModeRefreshTimer = window.setInterval(() => {
      handleLiveModeRefresh();
    }, interval);
  } else {
    window.clearInterval(liveModeRefreshTimer);
  }

  keepSessionAlive(isRunning);
}
